class DrawerSearchSection extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.drawerClass = "wt-drawer-search";
    this.classDrawerActive = `${this.drawerClass}--active`;
    this.pageOverlayClass = "search-overlay";
    this.activeOverlayBodyClass = `${this.pageOverlayClass}-on`;
    this.body = document.body;

    this.triggerQuery = [
      ".wt-header__search-trigger",
      ".wt-header__search__close",
      ".search-results__terms",
    ].join(", ");
    this.triggers = () => document.querySelectorAll(this.triggerQuery);

    // search stuff
    this.cachedResults = {};
    this.input = this.querySelector('input[name="q"]');
    this.clearButton = this.querySelector(".wt-header__search__clear-button");
    this.closeButton = this.querySelector(".wt-header__search__close");
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]",
    );
    this.searchProperties = this.dataset.searchProperties;

    this.mainTrigger = this.querySelector(".wt-header__search-trigger");
    this.emptyAnnouncement = this.querySelector(".search-empty");
    this.searchResultTop = this.querySelector(".search-result-top");

    this.isVisibleClearButton = false;

    this.saveSuggestionMenuInDesignMode =
      this.saveSuggestionMenuInDesignMode.bind(this);

    this.isPredictiveSearchAvailable = this.hidePredictiveSearch();
    this.isPredictiveSearchEnabled = this.dataset.enablePredictiveSearch === 'true';

    this.setupEventListeners();

    this.toggleTabindexElements = [this.input, this.closeButton];

    this.suggestionMenuContent = this.querySelector(".search-result-top").cloneNode(true);
    this.timeOut = null;

    this.updateSearchPanelCover = this.updateSearchPanelCover.bind(this);
    this.handleSearchPanelCover = this.handleSearchPanelCover.bind(this);
    this.syncScrollbarWidth = this.syncScrollbarWidth.bind(this);

    this.syncScrollbarWidth();
    window.addEventListener("resize", this.syncScrollbarWidth, {
      passive: true,
    });

    this.init();
  }

  syncScrollbarWidth() {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    document.documentElement.style.setProperty(
      "--scrollbar-width",
      `${Math.max(scrollbarWidth, 0)}px`,
    );
  }

  getSearchPanelCoverHeight() {
    const header = document.querySelector("header.page-header");
    const announcement = document.querySelector(".wt-announcement");
    let coverHeight = 0;

    if (announcement) {
      const announcementStyle = getComputedStyle(announcement);
      if (
        announcementStyle.display !== "none" &&
        announcementStyle.visibility !== "hidden"
      ) {
        coverHeight = Math.max(
          coverHeight,
          announcement.getBoundingClientRect().bottom,
        );
      }
    }

    if (header) {
      coverHeight = Math.max(coverHeight, header.getBoundingClientRect().bottom);
    }

    return Math.ceil(coverHeight);
  }

  updateSearchPanelCover() {
    const rootStyles = getComputedStyle(document.documentElement);
    const headerBarHeight = parseFloat(
      rootStyles.getPropertyValue("--header-bar-height"),
    );
    const announcementBarHeight = parseFloat(
      rootStyles.getPropertyValue("--announcement-bar-height"),
    );
    const measuredHeight =
      (Number.isFinite(headerBarHeight) ? headerBarHeight : 0) +
      (Number.isFinite(announcementBarHeight) ? announcementBarHeight : 0);

    const coverHeight =
      measuredHeight > 0 ? measuredHeight : this.getSearchPanelCoverHeight();

    document.documentElement.style.setProperty(
      "--search-panel-cover-height",
      `${coverHeight}px`,
    );
  }

  bindSearchPanelCover() {
    this.syncScrollbarWidth();
    this.updateSearchPanelCover();
    window.addEventListener("resize", this.handleSearchPanelCover, {
      passive: true,
    });
    window.addEventListener("scroll", this.handleSearchPanelCover, {
      passive: true,
    });
  }

  unbindSearchPanelCover() {
    window.removeEventListener("resize", this.handleSearchPanelCover);
    window.removeEventListener("scroll", this.handleSearchPanelCover);
    document.documentElement.style.removeProperty("--search-panel-cover-height");
    document.documentElement.style.removeProperty("--scrollbar-width");
  }

  handleSearchPanelCover() {
    if (this.isOpen) {
      this.syncScrollbarWidth();
      this.updateSearchPanelCover();
    }
  }


  getFocusableElements() {
    const focusableElementsSelector =
      "button, [href], input:not([type='hidden']), select, [tabindex]";
    const focusableElements = () =>
      Array.from(this.querySelectorAll(focusableElementsSelector)).filter(
        (el) => !el.hasAttribute("disabled") && el.tabIndex >= 0,
      );

    return {
      focusableElements,
      first: focusableElements()[0],
      last: focusableElements()[focusableElements().length - 1],
    };
  }

  // fixOverlayIssue() {
  //     const body = this.body;
  //
  //     if(body.classList.contains(this.activeOverlayBodyClass)) {
  //         const offsetTop = -parseInt(body.style.top);
  //         body.style.position = 'initial';
  //         body.style.top = 'initial';
  //         body.style.left = 'initial';
  //         window.scrollTo(0, offsetTop);
  //
  //     } else {
  //         // body.style.top = -document.documentElement.scrollTop+'px';
  //         // body.style.left = '0px';
  //         // body.style.position = 'fixed';
  //     }
  // }

  onToggle() {
    if (this.hasAttribute("open")) {
      this.removeAttribute("open");
      setTabindex(this.toggleTabindexElements, "-1");
      setTabindex([this.mainTrigger], "0");
      this.isOpen = false;
    } else {
      this.setAttribute("open", "");
      setTabindex(this.toggleTabindexElements, "0");
      setTabindex([this.mainTrigger], "-1");
      this.isOpen = true;
    }
  }

  focusSearchInput() {
    if (!this.input) return;

    requestAnimationFrame(() => {
      if (!this.isOpen || !this.input) return;

      this.input.focus({ preventScroll: true });

      try {
        const end = this.input.value.length;
        this.input.setSelectionRange(end, end);
      } catch (error) {
        // setSelectionRange can fail on some mobile browsers
      }
    });
  }

  toggleDrawerClasses() {
    const wasOpen = this.isOpen;

    if (!wasOpen) {
      this.syncScrollbarWidth();
      document.documentElement.style.setProperty(
        "--search-panel-cover-height",
        `${this.getSearchPanelCoverHeight()}px`,
      );
    }

    this.onToggle();
    // this.fixOverlayIssue();
    this.classList.toggle(this.classDrawerActive);
    this.body.classList.toggle(this.activeOverlayBodyClass);

    if (this.isOpen) {
      this.bindSearchPanelCover();
      this.focusSearchInput();
    } else {
      this.unbindSearchPanelCover();

      if (wasOpen) {
        setTimeout(() => {
          this.mainTrigger?.focus();
        }, 0);
      }
    }
  }

  init() {
    this.triggers().forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleDrawerClasses();
      });
    });

    this.clearButton.addEventListener("click", () => {
      this.input.value = "";
      this.clearButton.style.display = "none";
      this.isVisibleClearButton = false;
      this.clearResults();
    });

    this.addEventListener("keydown", (e) => {
      const isTabPressed =
        e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
      const { first, last } = this.getFocusableElements();

      if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
        if (this.isOpen) {
          this.toggleDrawerClasses();
        }
      }

      if (isTabPressed) {
        if (this.isOpen) {
          if (e.shiftKey && document.activeElement === first) {
            last.focus();
            e.preventDefault();
          } else if (!e.shiftKey && document.activeElement === last) {
            first.focus();
            e.preventDefault();
          }
        }
      }
    });

    this.input.addEventListener("input", () => {
      if (this.input.value.length > 0 && !this.isVisibleClearButton) {
        this.clearButton.style.display = "flex";
        this.clearButton.setAttribute("tabindex", "0");
        this.isVisibleClearButton = true;
      } else if (this.input.value.length === 0 && this.isVisibleClearButton) {
        this.clearButton.style.display = "none";
        this.clearButton.setAttribute("tabindex", "-1");
        this.isVisibleClearButton = false;
      }
    });
  }

  hidePredictiveSearch() {
    // when predictive search is not available, we need to hide the predictive search results
    const featuresTag = document.getElementById("shopify-features");
    if (featuresTag) {
      const featuresData = JSON.parse(featuresTag.textContent);
      if (featuresData.predictiveSearch === false) {
        return false;
      }
    }
    return true;
  }

  // search stuff
  setupEventListeners() {
    const form = this.querySelector("form.store-search-form");
    form.addEventListener("submit", this.onFormSubmit.bind(this));
    if (this.isPredictiveSearchAvailable && this.isPredictiveSearchEnabled) {
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this),
      );
    }

    if (Shopify.designMode) {
      document.addEventListener(
        "shopify:section:load",
        this.saveSuggestionMenuInDesignMode,
      );
    }
  }

  saveSuggestionMenuInDesignMode() {
    if (this.body.classList.contains(this.activeOverlayBodyClass))
      this.classList.toggle(this.classDrawerActive);
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (searchTerm.length) {
      this.getSearchResults(searchTerm);
      this.removeAttribute("empty");
    } else {
      this.clearResults();
    }
  }

  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    )
      event.preventDefault();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent("resources[type]")}=product,page,article,collection,query&${encodeURIComponent("resources[limit_scope]")}=each&${encodeURIComponent("resources[limit]")}=6&${encodeURIComponent("resources[options][fields]")}=${encodeURIComponent(this.searchProperties)}&section_id=predictive-search`,
    )
      .then((response) => {
        if (!response.ok) {
          let error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    if (!this.statusElement) return;

    const statusTextElement =
      this.statusElement.querySelector(".predictive-search-status__text") ||
      this.statusElement;

    this.statusElement.setAttribute("aria-hidden", "false");
    statusTextElement.textContent = statusText || "";

    clearTimeout(this.timeOut);
    this.timeOut = setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    this.setAttribute("results", true);

    this.setLiveRegionResults();
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]")
        ?.textContent,
    );
  }

  clearResults() {
    this.removeAttribute("results");
    this.setAttribute("empty", true);
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.statusElement.innerHTML = "";
    this.statusElement.appendChild(this.suggestionMenuContent.cloneNode(true));
    const statusTextElement = document.createElement("div");
    statusTextElement.className = "predictive-search-status__text";
    this.statusElement.appendChild(statusTextElement);

    clearTimeout(this.timeOut);
    setTimeout(() => {
      this.statusElement.removeAttribute("aria-hidden");
    }, 300);
  }
}

customElements.define("search-drawer", DrawerSearchSection);
